import { defineStore } from 'pinia'
import axiosInstance from '@/services'
import { useDashboardStore } from './dashboard'
import { useAuthStore } from './auth'

export const useFavoriteService = defineStore('favoriteStore', {
  state: () => {
    return {
      favorites: []
    }
  },
  getters: {
    favoriteIds() {
      return this.favorites.map((f) => f.serviceTransId)
    }
  },
  actions: {
    isInFavorite(service) {
      return this.favoriteIds.includes(service.transactionId)
    },
    async fetchFavorites() {
      const response = await axiosInstance.post('/api/dashboard/getUserFavoriteServices')
      this.favorites = response.map((r) => {
        return {
          ...r,
          serviceId: r.serviceTransId,
          transactionId: r.serviceTransId
        }
      })
    },
    async toggleFavoriteStatus(service, value = true) {
      const dashboardStore = useDashboardStore()
      const authStore = useAuthStore()

      // check if service.serviceTransId is in the favorites list
      const path = this.isInFavorite(service)
        ? '/api/dashboard/deleteUserFavoriteService'
        : 'api/dashboard/addUserFavoriteService'

      const adminRegionId = dashboardStore.selectedRegion.id

      const sponsorFileDepartment = authStore.individualInfo.sponsorFileDepartments.find(
        (s) => s.immigrationDepartment.admninstrativeRegion.id == adminRegionId
      )

      const body = {
        serviceTransId: service.transactionId || service.id,
        serviceTransactionId: service.transactionId || service.id,
        lookupApplicationId: adminRegionId,
        AdministrativeRegionId: adminRegionId,
        lookupAdminRegionId: adminRegionId,
        immigrationDepartmentId: sponsorFileDepartment?.immigrationDepartmentId
      }

      await axiosInstance.post(path, body)

      await this.fetchFavorites()
    }
  }
})
